var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sticker"},[_c('v-icon',{attrs:{"name":"swipe-up","size":26}}),_c('span',{staticClass:"sticker__title"},[_vm._v("Swipe up")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }